/**
 * Games Visor — Branding centralisé
 * Source unique pour le nom de la plateforme et le composant visuel de marque.
 *
 * Typographie de marque : Bricolage Grotesque 800 (ExtraBold)
 * Le texte "Games Visor" EST le logo — pas de pictogramme, pas de symbole.
 */
import React from 'react';

export const APP_NAME = 'Games Visor';
export const APP_EMAIL = 'contact@gamesvisor.com';
export const APP_DESCRIPTION = 'La plateforme B2B pour professionnels du jeu de société';
export const APP_COPYRIGHT = `© ${new Date().getFullYear()} Games Visor. Tous droits réservés.`;

/**
 * Constante de style de la police de marque
 */
const BRAND_FONT = {
  fontFamily: "'Bricolage Grotesque', sans-serif",
  fontWeight: 800,
  letterSpacing: '-0.03em',
};

/**
 * BrandLogo — Le composant de marque principal.
 * "Games Visor" affiché en typographie distinctive, jouant le rôle de logo.
 *
 * @param {'sm' | 'md' | 'lg' | 'xl'} size — Taille du rendu
 * @param {string} className — Classes CSS additionnelles
 * @param {'light' | 'dark'} variant — Couleur (dark = texte sombre, light = texte blanc)
 */
export const BrandLogo = ({ size = 'md', className = '', variant = 'dark' }) => {
  const sizes = {
    sm: 'text-lg',
    md: 'text-[1.65rem] leading-none',
    lg: 'text-[2rem] leading-none',
    xl: 'text-[2.5rem] leading-none',
  };

  const colorClass = variant === 'light' ? 'text-white' : '';
  const colorStyle = variant === 'dark' ? { color: 'var(--ludo-text, #111)' } : {};

  return (
    <span
      className={`${sizes[size]} ${colorClass} ${className} select-none`}
      style={{ ...BRAND_FONT, ...colorStyle }}
      data-testid="brand-logo"
    >
      Games Visor
    </span>
  );
};

export default BrandLogo;
